import { createFeatureSelector } from '@ngrx/store';
import { ProjectState } from '@projects/reducers';

export const selectProjectsModule = createFeatureSelector<ProjectState>('projects');
